import { Container, Grid, Typography } from '@mui/material';
import { useState } from 'react';
import { useVentas } from './hooks/useVentas';
import VentaForm from './VentaForm';
import VentasTable from './VentasTable';
import VentasResumen from './VentasResumen';

export default function LibroVentasApp() {
  const { ventas, agregarVenta, editarVenta, anularVenta } = useVentas();
  const [editing, setEditing] = useState(null);

  return (
    <Container maxWidth="xl" sx={{ py: 4 }}>
      <Typography variant="h4" align="center" gutterBottom>
        📗 Libro de Ventas
      </Typography>

      <VentasResumen ventas={ventas} />

      <Grid container spacing={3}>
        <Grid item xs={12} md={4}>
          <VentaForm
            editing={editing}
            onSubmit={data => {
              editing
                ? editarVenta(editing.id, data)
                : agregarVenta(data);
              setEditing(null);
            }}
          />
        </Grid>

        <Grid item xs={12} md={8}>
          <VentasTable
            ventas={ventas}
            onEdit={setEditing}
            onAnular={anularVenta}
          />
        </Grid>
      </Grid>
    </Container>
  );
}
